module.exports = __webpack_public_path__ + "img/icon-practice.a013b880.png";